import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';

const DocPage = ({ title, lastUpdated, sections }) => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <div className="border-b border-neutral-200 bg-neutral-50 pt-36 sm:pt-40">
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8 sm:py-10">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-medium text-neutral-500 hover:text-neutral-900"
        >
          <ArrowLeft size={14} /> Back to PetCart
        </Link>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-neutral-900 sm:text-4xl">
          {title}
        </h1>
        <p className="mt-2 text-xs uppercase tracking-wide text-neutral-500">
          Last updated · {lastUpdated}
        </p>
      </div>
    </div>

    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
      <div className="grid gap-10 lg:grid-cols-[220px_1fr]">
        <aside className="hidden lg:block">
          <nav className="sticky top-24">
            <p className="mb-3 text-[11px] font-semibold uppercase tracking-wider text-neutral-500">
              On this page
            </p>
            <ul className="space-y-2 border-l border-neutral-200">
              {sections.map((s) => (
                <li key={s.id}>
                  <a
                    href={`#${s.id}`}
                    className="-ml-px block border-l border-transparent pl-3 py-1 text-sm text-neutral-600 hover:border-primary hover:text-neutral-900"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <article className="max-w-2xl space-y-10">
          {sections.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28">
              <h2 className="text-xl font-semibold text-neutral-900 sm:text-2xl">{s.title}</h2>
              <div className="mt-3 space-y-3 text-[15px] leading-7 text-neutral-700">
                {s.body}
              </div>
            </section>
          ))}
          <p className="border-t border-neutral-200 pt-6 text-sm text-neutral-500">
            Questions about this document? Write to{' '}
            <a href="mailto:shekhar@petcart.com" className="text-primary font-medium hover:underline">
              shekhar@petcart.com
            </a>
            .
          </p>
        </article>
      </div>
    </div>

    <Footer />
  </div>
);

export default DocPage;
